<div class="campanha-container">
  <div class="row">
    <div class="col-md-6 col-lg-3 mb-4">
      <div class="card">
        <img src="assets/images/campanha/1.png" class="card-img-top" alt="Campanha 1">
        <div class="card-body">
          <h5 class="card-title">Campanha 1</h5>
          <div class="upload-section">
            <input type="file" class="d-none" id="upload1" accept="image/*" (change)="onFileSelected($event, 1)">
            <button class="btn btn-primary btn-sm w-100" >
              <i class="bi bi-upload m-r-5"></i>
              Alterar Imagem
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-lg-3 mb-4">
      <div class="card">
        <img src="assets/images/campanha/2.png" class="card-img-top" alt="Campanha 2">
        <div class="card-body">
          <h5 class="card-title">Campanha 2</h5>
          <div class="upload-section">
            <input type="file" class="d-none" id="upload2" accept="image/*" (change)="onFileSelected($event, 2)">
            <button class="btn btn-primary btn-sm w-100" >
              <i class="bi bi-upload m-r-5"></i>
              Alterar Imagem
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-lg-3 mb-4">
      <div class="card">
        <img src="assets/images/campanha/3.png" class="card-img-top" alt="Campanha 3">
        <div class="card-body">
          <h5 class="card-title">Campanha 3</h5>
          <div class="upload-section">
            <input type="file" class="d-none" id="upload3" accept="image/*" (change)="onFileSelected($event, 3)">
            <button class="btn btn-primary btn-sm w-100" >
              <i class="bi bi-upload m-r-5"></i>
              Alterar Imagem
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-lg-3 mb-4">
      <div class="card">
        <img src="assets/images/campanha/4.png" class="card-img-top" alt="Campanha 4">
        <div class="card-body">
          <h5 class="card-title">Campanha 4</h5>
          <div class="upload-section">
            <input type="file" class="d-none" id="upload4" accept="image/*" (change)="onFileSelected($event, 4)">
            <button class="btn btn-primary btn-sm w-100" >
              <i class="bi bi-upload m-r-5"></i>
              Alterar Imagem
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> 